export const getSearchPreferences = ({ isFollowup, isInSameThread, sourcesOverride, firstResultSources, defaultSources, }) => {
    if (sourcesOverride) {
        return {
            finalSources: sourcesOverride,
        };
    }
    // For new queries, use defaults
    if (!isFollowup || !isInSameThread) {
        return {
            finalSources: defaultSources,
        };
    }
    // For follow-ups, use current source selection (defaultSources) if available,
    // otherwise inherit from the first result
    const finalSources = defaultSources.length > 0
        ? defaultSources
        : Array.isArray(firstResultSources)
            ? firstResultSources
            : [];
    return {
        finalSources,
    };
};
//# sourceMappingURL=searchPreferencesUtils.js.map